module.exports = __webpack_public_path__ + "static/img/summer_cheliziPic.e6cc9cf6.png";